<template>
  <div>


<h2 class="goth" ref="gramtitel">Ackusativobjekt</h2>



<div class="grammatikparagrafbredd leftorient">
    <h4 class="grammatikparagrafbredd leftorient">Satsanalys</h4><br>
<p class="grammatikparagrafbredd leftorient">Försök att ta ut satsdelarna i följande mening:</p><br>

<div class="grammatikparagrafbredd leftorient storre"><div class="bla inlajn">Peter</div> köper <div class="gron inlajn">ett äpple</div>.</div><br>
<div class="grammatikparagrafbredd leftorient inlajn"><div class="bla inlajn">(Peter</div> kauft <div class="gron inlajn">einen Apfel</div>.)</div>

<br><br>



<div class="grammatikparagrafbredd leftorient ruta">

    <p><b>Predikatet</b> beskriver själva handlingen i en sats; vad någon gör eller vad som händer.
        Det är <u>alltid ett verb</u> (eller ibland flera, om hjälpverb finns med).
    <p> I exemplet: <i> köper</i></p>

<br>
<br><div class="bla inlajn"> <b>Subjektet</b></div> är den eller det som utför själva handlingen - den aktiva.
    Det står alltid i nominativ, grundform.<br>

<p> I exemplet: <i><div class="bla inlajn"> Peter</div></i></p>
<br>

<br><div class="gron inlajn"> <b>Ackusativobjektet</b></div> kan man få reda på genom frågan:
    <i>Vad</i> + <b>predikat</b> + <div class="bla inlajn"><b>subjekt</b></div>.<br>

<br> Alltså i exemplet: <i>"Vad <b>köper</b> <div class="bla inlajn"> Peter?"</div></i>  - Svar: <i><div class="gron inlajn"> ett äpple</div></i> <br>
<br>

<p class="mindre">Observera att efter verben <i>är</i> och <i>blir</i> kommer <b> <div class="ljusbla inlajn">predikatsfyllnad</div></b> som alltid står i nominativ.</p>
<p class="mindre">T.ex: <i><div class="bla inlajn">Kalle</div> är <div class="ljusbla inlajn">en hund</div>.</i></p>
<div class="mindre">(Trots att man skulle kunna fråga" Vad + predikat + subjekt?" [Vad är kalle? - En hund] så är svaret
    här <div class="ljusbla inlajn">predikatsfyllnad</div> och <b>inte </b>  <div class="gron inlajn"> <strike>ackusativobjekt</strike></div>)
</div>
<br>



</div>



<div class="grammatikparagrafbredd leftorient">

<div class="quasi-p">På tyska blir den inga skillnader i formen på substantiv när de står i ackusativ, utom när
    de är maskulina i singular, då bestämd och obestämd artikel ändras.
    </div>


</div>
<br><br>
<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i nominativ och ackusativ</h4><br>


    <table class="">

        <tr class="leftorient">
            <td></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="vit bgbla">der</td>
            <td class="vit bgbla">das</td>
            <td class="vit bgbla">die</td>
            <td class="vit bgbla">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="vit bggron"><b>den</b></td>
            <td class="vit bggron">das</td>
            <td class="vit bggron">die</td>
            <td class="vit bggron">die</td>
        </tr>

    </table>
    <br><br>
<div class="ruta x-pad">
<div class="kvasi-p"> <i><div class="bla inlajn">Mannen</div> står där.<br>
    <div class="bla inlajn">Der Mann</div> steht da.</i></div><br>

<div class="kvasi-p"><i>Ser <div class="bla inlajn">du </div> <div class="gron inlajn">mannen</div>?<br>
    Siehst <div class="bla inlajn">du </div> <div class="gron inlajn">de<b>n</b> Mann</div> ?</i></div>

</div>
<br>
<p class="grammatikparagrafbredd leftorient">Ord som <i>dieser</i> böjs på liknande sätt (blir alltså <i><b>diesen</b></i> i ackusativ maskulinum).</p>
<br>

<div class="ruta x-pad">
<div class="kvasi-p"><i>Känner <div class="bla inlajn">du </div> <div class="gron inlajn"> den här mannen</div>?<br>
    Kennst <div class="bla inlajn">du </div> <div class="gron inlajn">dies<b>en</b> Mann</div> ?</i></div>
</div>
    <br><br>


<br>
    <h4 class="grammatikparagrafbredd leftorient">Obestämd artikel i nominativ och ackusativ</h4><br>


        <table class="">

            <tr class="leftorient">
                <td></td>
                <td class="ljusgra">mask.</td>
                <td class="ljusgra">neutr.</td>
                <td class="ljusgra">fem.</td>
                <td class="ljusgra">plur.</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">nom.</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">eine</td>
                <td class="vit bgbla">(keine)</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">ack.</td>
                <td class="vit bggron"><b>einen</b></td>
                <td class="vit bggron">ein</td>
                <td class="vit bggron">eine</td>
                <td class="vit bggron">(keine)</td>
            </tr>

        </table>
<br>
<p class="grammatikparagrafbredd leftorient">Ord som <i>mein, dein, kein</i> böjs på liknande sätt (blir alltså <i><b>meinen, keinen</b></i> o.s.v. i ackusativ maskulinum).</p>

<br>

<div class="ruta x-pad">
<div class="kvasi-p"><i><div class="bla inlajn">Jag </div> har <div class="gron inlajn"> ingen bil</div>.<br>
    <div class="bla inlajn">Ich </div> habe <div class="gron inlajn"> kein<b>en</b> Wagen</div>.</i></div>
</div>




<br><br><p class="grammatikparagrafbredd leftorient">Personliga pronomen i ackusativ får dock en annan form än i nominativ i de flesta fall.</p>

<br><br>
<h4 class="grammatikparagrafbredd leftorient">Personliga pronomen i nominativ och ackusativ</h4><br>
<table class="">

    <tr class="leftorient">
        <td class="ljusgra">svenska</td>
        <td class="ljusgra">nominativ</td>
        <td class="ljusgra">ackusativ</td>
    </tr>
<tr></tr>
    <tr class="leftorient">
        <td class="ljusgra">jag / mig</td>
        <td class="vit bgbla">ich</td>
        <td class="vit bggron"><b>mich</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">du / dig</td>
        <td class="vit bgbla">du</td>
        <td class="vit bggron"><b>dich</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">han / honom<br>det / det<br>hon / henne</td>
        <td class="vit bgbla">er<br>es<br>sie</td>
        <td class="vit bggron"><b>ihn</b><br>es<br>sie</td>
    </tr>
<tr></tr>
    <tr class="leftorient">
        <td class="ljusgra">vi / oss</td>
        <td class="vit bgbla">wir</td>
        <td class="vit bggron"><b>uns</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ni / er</td>
        <td class="vit bgbla">ihr</td>
        <td class="vit bggron"><b>euch</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">de / dem<br>Ni / Er</td>
        <td class="vit bgbla">sie<br>Sie</td>
        <td class="vit bggron">sie<br>Sie</td>
    </tr>




</table>


<br><br>

<div class="ruta x-pad">
<div class="kvasi-p"><i>Ser <div class="bla inlajn">ni </div> <div class="gron inlajn">mig</div> därifrån?<br>
    Seht <div class="bla inlajn">ihr </div> <div class="gron inlajn">mich</div> von dort?</i></div>



    <br>
    <div class="kvasi-p"><i><div class="bla inlajn">Jag </div> ser i alla fall<div class="gron inlajn"> er</div>.<br>
        <div class="bla inlajn">Ich </div> sehe auf jedem fall <div class="gron inlajn"> euch</div>.</i></div>

</div>
        <br><br>


</div>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "ackusativobjekt ackusativ"
            }
        ]
    }
}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
